import React, { useState, useEffect } from 'react';
import CartSlider from '../../Customer/Cart/imgSlider';
import '../../Customer/Cart/cart.css';
import { connect, useDispatch } from 'react-redux';
import { AddToCart, updateCartItem } from '../../../Redux/actions/cartAction';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { Route, useRoutes } from 'react-router-dom';

const CartModal = ({ CartValue, closeModal, isEdit, editingItem, Currency }) => {
  // let pro = useRoutes();
  // let props = pro.props;
  debugger;
  const dispatch = useDispatch();
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [specialInstructions, setSpecialInstructions] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [stockData, setStockData] = useState(null);
  const [isCheckingStock, setIsCheckingStock] = useState(false);
  const [stockError, setStockError] = useState(null);
  const [hasVariants, setHasVariants] = useState(false);
  const [serialNumbers, setSerialNumbers] = useState(['']);

  useEffect(() => {
    // Check if item has variants
    const variants = CartValue?.itemMasterVarients;
    const hasMultipleVariants = variants && variants.length > 0;
    setHasVariants(hasMultipleVariants);

    if (isEdit && editingItem) {
      // Pre-fill data when editing
      setSelectedVariant(editingItem.selectedVariant || null);
      setSpecialInstructions(editingItem.specialInstructions || '');
      setQuantity(editingItem.quantity || 1);

      // 🆕 Initialize serial numbers in edit mode
      if (editingItem.serialNumbers && editingItem.serialNumbers.length) {
        setSerialNumbers(editingItem.serialNumbers);
      } else if (editingItem.serialNumber) {
        // Backward compatibility if only one serial was stored earlier
        const q = editingItem.quantity || 1;
        setSerialNumbers(Array(q).fill(editingItem.serialNumber));
      } else {
        const q = editingItem.quantity || 1;
        setSerialNumbers(Array(q).fill(''));
      }
    } else {
      // For new items
      if (hasMultipleVariants) {
        setSelectedVariant(variants[0]);
      } else {
        const defaultVariant = {
          recordId: CartValue?.record_Id || CartValue?.recordId,
          itemNo: CartValue?.itemNo,
          itemDescription: CartValue?.itemName || CartValue?.itemDescription,
          salePrice: CartValue?.salePrice || CartValue?.purchasePrice || 0,
          barcode: CartValue?.barcode || CartValue?.exp10,
          vat: CartValue?.vat || CartValue?.taxRate || 0,
        };
        setSelectedVariant(defaultVariant);
      }

      // 🆕 For new items default to one empty serial field
      setSerialNumbers(['']);
    }
  }, [isEdit, editingItem, CartValue]);
  useEffect(() => {
    setSerialNumbers((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      if (safePrev.length === quantity) return safePrev;

      if (safePrev.length < quantity) {
        // Add empty serials for new quantity slots
        return [...safePrev, ...Array(quantity - safePrev.length).fill('')];
      }
      // Trim extra serials if quantity decreased
      return safePrev.slice(0, quantity);
    });
  }, [quantity]);

  // Check stock when variant is selected
  useEffect(() => {
    if (selectedVariant && selectedVariant.itemNo) {
      checkStock(selectedVariant.itemNo);
    } else if (selectedVariant && !selectedVariant.itemNo && CartValue?.itemNo) {
      // Fallback to main item's itemNo if variant doesn't have one
      checkStock(CartValue.itemNo);
    }
  }, [selectedVariant, CartValue]);
  useEffect(() => {
    if (isEdit && editingItem) {
      setSerialNumbers(editingItem.serialNumbers || ['']);
    }
  }, [isEdit, editingItem]);

  const checkStock = async (materialNo) => {
    if (!materialNo) {
      console.warn('No material number provided for stock check');
      return;
    }

    setIsCheckingStock(true);
    setStockError(null);

    try {
      const apiService = new ApiService();
      const requestBody = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/stock-processing-confirmation-api',
          templateName: 'MaterialStockByLocationRequest',
          CountryIdentifier: 'zaf',
          Plant: '2402',
          Material: materialNo.toString(),
          token: await localStorage.getItem('Token'),
        },
      };

      const response = await apiService.post('GET_MATERIAL_STOCK', requestBody);

      if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
        setStockData(response.data.result);
      } else {
        setStockError('Unable to fetch stock information');
        setStockData(null);
      }
    } catch (error) {
      console.error('Stock check failed:', error);
      setStockError('Stock check failed');
      setStockData(null);
    } finally {
      setIsCheckingStock(false);
    }
  };

  const handleVariantSelection = (variant) => {
    setSelectedVariant(variant);
  };

  const handleSpecialInstructionsChange = (event) => {
    setSpecialInstructions(event.target.value);
  };
  const handleSerialChange = (index, value) => {
    setSerialNumbers((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const handleQuantityChange = (increment) => {
    if (increment) {
      setQuantity((prev) => {
        const newQty = prev + 1;
        // Check if new quantity exceeds available stock
        if (stockData && stockData.quantityNew < newQty) {
          toast.warning(`Only ${stockData.quantityNew} items available in stock`);
          return stockData.quantityNew;
        }
        return newQty;
      });
    } else {
      setQuantity((prev) => Math.max(1, prev - 1));
    }
  };

  const calculateTotalAmount = () => {
    let total = 0;

    // Price from selected variant or main item
    if (selectedVariant) {
      total = parseFloat(selectedVariant.salePrice || 0);
    } else if (CartValue?.salePrice) {
      total = parseFloat(CartValue.salePrice || 0);
    }

    total = total * quantity;
    return total.toFixed(2);
  };

  const handleATC = async () => {
    // For items without variants, we already have a default variant
    if (!selectedVariant) {
      toast.error('Please select a variant');
      return;
    }

    // Final stock check before adding to cart
    if (stockData && stockData.quantityNew <= 0) {
      toast.error('This item is out of stock');
      return;
    }

    if (stockData && stockData.quantityNew < quantity) {
      toast.error(`Only ${stockData.quantityNew} items available in stock`);
      return;
    }

    // If stock check is still in progress, wait for it
    if (isCheckingStock) {
      toast.info('Checking stock availability...');
      return;
    }

    const mergedData = {
      id: selectedVariant.itemNo || selectedVariant.recordId || CartValue?.itemNo,
      name: CartValue?.itemName || selectedVariant.itemDescription,
      barcode: selectedVariant.barcode || CartValue?.barcode,
      quantity: quantity,
      price: parseFloat(selectedVariant.salePrice || 0),

      // 🆕 Carry serial numbers both on the root and inside `item`
      serialNumbers, // full array
      serialNumber: serialNumbers[0] || '', // backward compatibility

      item: {
        ...CartValue,
        itemNo: selectedVariant.itemNo || CartValue?.itemNo,
        salePrice: selectedVariant.salePrice,
        serialNumbers,
        serialNumber: serialNumbers[0] || '',
      },

      selectedVariant: hasVariants ? selectedVariant : null,
      specialInstructions,
      stockData,
      discount: isEdit ? editingItem?.discount || 0 : 0,
      discountType: isEdit ? editingItem?.discountType || null : null,
    };

    if (isEdit) {
      // Update existing item
      dispatch(
        updateCartItem({
          ...mergedData,
          index: editingItem.index,
          itemData: editingItem.itemData,
        }),
      );
      toast.success('Cart updated successfully');
    } else {
      // Add new item
      dispatch(AddToCart(mergedData));
      toast.success('Item added to cart');
    }

    closeModal(true);
  };

  const getStockStatusColor = () => {
    if (!stockData) return '#6c757d';
    if (stockData.quantityNew <= 0) return '#dc3545';
    if (stockData.quantityNew <= 5) return '#ffc107';
    return '#28a745';
  };

  const getStockStatusText = () => {
    if (isCheckingStock) return 'Checking stock...';
    if (stockError) return 'Stock check failed';
    if (!stockData) return 'Stock unknown';
    if (stockData.quantityNew <= 0) return 'Out of stock';
    if (stockData.quantityNew <= 5) return `Low stock (${stockData.quantityNew} left)`;
    return `In stock (${stockData.quantityNew} available)`;
  };

  const isOutOfStock = stockData && stockData.quantityNew <= 0;
  const isLowStock = stockData && stockData.quantityNew > 0 && stockData.quantityNew <= 5;

  // Get display name for the item
  const getItemDisplayName = () => {
    return CartValue?.itemName || CartValue?.itemDescription || editingItem?.name || 'Item';
  };

  // Get display price
  const getDisplayPrice = () => {
    if (selectedVariant?.salePrice) return selectedVariant.salePrice;
    if (CartValue?.salePrice) return CartValue.salePrice;
    if (CartValue?.purchasePrice) return CartValue.purchasePrice;
    return 0;
  };

  return (
    <div className="m-0 p-0 pt-5 px-5">
      <div className="row py-lg-3">
        <div className="col-lg-4">
          <CartSlider val={CartValue} />
        </div>
        <div className="col-lg-8 px-lg-5">
          <div className="CartName">{getItemDisplayName()}</div>
          <div className="cartPrice pt-2">
            {Currency?.currency?.code} {calculateTotalAmount()}
          </div>

          {/* Stock Status Display */}
          <div className="py-3">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-bold">Stock Status:</span>
              <span
                className="badge"
                style={{
                  backgroundColor: getStockStatusColor(),
                  color: 'white',
                  fontSize: '12px',
                  padding: '6px 12px',
                }}
              >
                {getStockStatusText()}
              </span>
              {isCheckingStock && (
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>

            {isOutOfStock && (
              <div className="alert alert-danger mt-2 py-2">
                <small>This item is currently out of stock and cannot be added to cart.</small>
              </div>
            )}

            {isLowStock && (
              <div className="alert alert-warning mt-2 py-2">
                <small>Limited stock available. Only {stockData.quantityNew} items left.</small>
              </div>
            )}
          </div>

          {/* Quantity Selection */}
          <div className="py-3">
            <h6>Quantity</h6>
            <div className="d-flex align-items-center gap-3">
              <button className="btn btn-outline-secondary" onClick={() => handleQuantityChange(false)} disabled={quantity <= 1 || isOutOfStock}>
                -
              </button>
              <span className="h5 mb-0">{quantity}</span>
              <button
                className="btn btn-outline-secondary"
                onClick={() => handleQuantityChange(true)}
                disabled={isOutOfStock || (stockData && quantity >= stockData.quantityNew)}
              >
                +
              </button>
            </div>
            {stockData && quantity >= stockData.quantityNew && <small className="text-warning">Maximum available quantity selected</small>}
          </div>

          {/* Variant Selection - Only show if there are multiple variants */}
          {hasVariants && CartValue?.itemMasterVarients?.length > 1 && (
            <div className="py-lg-3">
              <h5 className="mt-3">Select Variant</h5>
              {CartValue.itemMasterVarients.map((variant) => (
                <div key={variant.recordId} className="form-check d-flex justify-content-between pb-3">
                  <div className="gap-3 d-flex">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="variantSelection"
                      checked={selectedVariant?.recordId === variant.recordId}
                      style={{ width: '26.81px', height: '26.81px' }}
                      onChange={() => handleVariantSelection(variant)}
                      disabled={isOutOfStock}
                    />
                    <label className="form-check-label checkItem">
                      {variant.itemDescription} - {Currency?.currency?.code} {variant?.salePrice}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Show single variant info if only one variant */}
          {hasVariants && CartValue?.itemMasterVarients?.length === 1 && (
            <div className="py-3">
              <div className="alert alert-info py-2">
                <small>
                  <strong>Selected:</strong> {selectedVariant?.itemDescription} - {Currency?.currency?.code} {selectedVariant?.salePrice}
                </small>
              </div>
            </div>
          )}
          {/* Serial Number Fields */}
          <div className="form-group py-3">
            <label className="pb-2">{quantity > 1 ? 'Serial Numbers (one per item)' : 'Serial Number (Optional)'}</label>

            {quantity === 1 ? (
              <input
                type="text"
                className="form-control"
                placeholder="Scan or type serial number..."
                value={serialNumbers[0] || ''}
                onChange={(e) => handleSerialChange(0, e.target.value)}
                disabled={isOutOfStock}
              />
            ) : (
              <div className="serial-numbers-list">
                {Array.from({ length: quantity }).map((_, idx) => (
                  <div key={idx} className="mb-2">
                    <label className="pb-1 small">Serial #{idx + 1}</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Serial for unit #${idx + 1}`}
                      value={serialNumbers[idx] || ''}
                      onChange={(e) => handleSerialChange(idx, e.target.value)}
                      disabled={isOutOfStock}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Special Instructions */}
          <div className="form-group py-3">
            <label className="special pb-3">Special Instructions</label>
            <textarea
              rows="4"
              cols="100"
              className="textarea form-control"
              placeholder="Enter any special instructions..."
              value={specialInstructions}
              onChange={handleSpecialInstructionsChange}
              disabled={isOutOfStock}
            ></textarea>
          </div>

          {/* Add to Cart Button */}
          <div className="row pt-lg-3">
            <div className="col-lg-12">
              <button
                onClick={handleATC}
                className={`w-100 AddBtn ${isOutOfStock ? 'btn-secondary' : ''}`}
                disabled={!selectedVariant || isOutOfStock || isCheckingStock || stockData === null}
              >
                {isCheckingStock
                  ? 'Checking Stock...'
                  : isOutOfStock
                    ? 'Out of Stock'
                    : stockData === null
                      ? 'Stock Unknown'
                      : isEdit
                        ? `Update Cart - ${Currency?.currency?.code} ${calculateTotalAmount()}`
                        : `Add to Cart - ${Currency?.currency?.code} ${calculateTotalAmount()}`}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(CartModal);
